import { render, staticRenderFns } from "./ResearchOutput.vue?vue&type=template&id=5750d1b7&scoped=true&"
import script from "./ResearchOutput.vue?vue&type=script&lang=js&"
export * from "./ResearchOutput.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutput.vue?vue&type=style&index=0&id=5750d1b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750d1b7",
  null
  
)

export default component.exports